module.exports = __webpack_public_path__ + "img/chat-right-fill.4f7fc56b.svg";